import {
  ACCESS_PERMISSION_KEYS,
  PROVIDER_ROUTE_BUCKET_MAP,
  PROVIDER_BUCKET_DEFAULT_ROUTE,
} from "@/constants/providerAccess.js";

function normalizeDeniedPermissions(permissionsDenied) {
  if (!Array.isArray(permissionsDenied)) {
    return [];
  }

  return Array.from(
    new Set(
      permissionsDenied
        .filter((value) => typeof value === "string")
        .map((value) => value.trim())
        .filter(Boolean)
    )
  );
}

function isPermissionDenied(permissionsDenied, key) {
  if (!key) {
    return false;
  }

  return normalizeDeniedPermissions(permissionsDenied).includes(String(key));
}

function getRouteBucket(routeName) {
  if (!routeName) {
    return null;
  }

  return PROVIDER_ROUTE_BUCKET_MAP[String(routeName)] || null;
}

function isAccessBucketAllowed(permissionsDenied, bucketKey) {
  if (!bucketKey) {
    return true;
  }

  return !isPermissionDenied(permissionsDenied, bucketKey);
}

function canAccessProviderRoute(routeName, permissionsDenied) {
  const bucket = getRouteBucket(routeName);

  if (!bucket) {
    return true;
  }

  return isAccessBucketAllowed(permissionsDenied, bucket);
}

function getAllowedAccessBuckets(permissionsDenied) {
  return ACCESS_PERMISSION_KEYS.filter((key) =>
    isAccessBucketAllowed(permissionsDenied, key)
  );
}

function hasAnyAllowedAccessBucket(permissionsDenied) {
  return getAllowedAccessBuckets(permissionsDenied).length > 0;
}

function getFirstAllowedAccessBucket(permissionsDenied) {
  return getAllowedAccessBuckets(permissionsDenied)[0] || null;
}

function getDefaultRouteForBucket(bucketKey) {
  if (!bucketKey) {
    return PROVIDER_BUCKET_DEFAULT_ROUTE.deliveries;
  }

  return (
    PROVIDER_BUCKET_DEFAULT_ROUTE[bucketKey] ||
    PROVIDER_BUCKET_DEFAULT_ROUTE.deliveries
  );
}

function buildProviderRouteTarget(routeName, providerId) {
  if (!routeName || !providerId) {
    return null;
  }

  return {
    name: routeName,
    params: {
      provider_id: String(providerId),
    },
  };
}

function resolveProviderAccessRedirect(providerId, permissionsDenied) {
  const preferredBucket =
    getFirstAllowedAccessBucket(permissionsDenied) || "deliveries";
  const routeName = getDefaultRouteForBucket(preferredBucket);

  return buildProviderRouteTarget(routeName, providerId);
}

export {
  normalizeDeniedPermissions,
  isPermissionDenied,
  getRouteBucket,
  isAccessBucketAllowed,
  canAccessProviderRoute,
  getAllowedAccessBuckets,
  hasAnyAllowedAccessBucket,
  getFirstAllowedAccessBucket,
  getDefaultRouteForBucket,
  buildProviderRouteTarget,
  resolveProviderAccessRedirect,
};
